import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const HISTORIE_DOKUMENTY_LIST = "historieDokumentyList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestDocumentsByIds(ids);
};

const getPozadavkyAllIds = (parent, filter) => {
  return QSignDataApi.findHistorickeDokumenty();
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        HISTORIE_DOKUMENTY_LIST,
        null,
        getPozadavkyAllIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(HISTORIE_DOKUMENTY_LIST, getRequestsByIds));
  };
}
export function invalidatePozadavky() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(HISTORIE_DOKUMENTY_LIST));
  };
}
export function filterPozadavky(filter) {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(HISTORIE_DOKUMENTY_LIST, filter));
  };
}
